import IconStar from "../icons/star";
import {AppAvatar, AppBox, AppTitle} from "../index";
import {Sizes} from "../../types/core-types";
import {Fragment} from "react";

interface YetToDecideProps {
    avatarSize?: Sizes | "2xl" | "3xl" | "4xl" | "5xl" | "6xl",
    textAs?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6",
    text?:string
}

export default function ToBeDecided({avatarSize = '2xl', textAs = "h4",text="TBD"}: YetToDecideProps) {
    return (
        <Fragment>
            <AppAvatar size={avatarSize} variant={'outline'} color={'gray'} username={'TBD'}
                       icon={<IconStar color={'rgba(var(--gray-200))'}/>}/>
            <AppTitle as={textAs}>
                {text}
            </AppTitle>
        </Fragment>
    )
}